import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dc72c7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BigPlaceholder P-Rel" }
const _hoisted_2 = { class: "BigContainer" }
const _hoisted_3 = {
  key: 0,
  class: "BigLoading"
}
const _hoisted_4 = { class: "P1em" }
const _hoisted_5 = {
  class: "O-75 P-Abs BG2 Shadow1 D-Flex Rad2 BGBlur",
  style: {"left":"0.6em","right":"0.6em","font-size":"min(1.5em, 3vw)","z-index":"100"}
}
const _hoisted_6 = {
  class: "M-Auto",
  style: {"padding":"0.5em 1em"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "H-Auto F2em color4 O-25"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "BG1 Shadow2 BGBlur",
  style: {"justify-content":"center"}
}
const _hoisted_13 = ["ToolTip"]
const _hoisted_14 = {
  key: 0,
  class: "D-Flex H-100 color2 O-50"
}
const _hoisted_15 = { class: "M-Auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!
  const _component_WhatsappBuuble = _resolveComponent("WhatsappBuuble")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.Loading.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_CookiesLoading)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["BigBody", _ctx.FillBodyHeight])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Translate('Choose Catalogue:')), 1)
              ]),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9
            ]),
            _createElementVNode("div", {
              class: "W-100 D-Flex FlexWrap H-Auto CardsHolder",
              style: _normalizeStyle([{"justify-content":"center"}, [_ctx.ViewType === 'GRID' ? 'gap: 2em 1em;' : '', _ctx.ViewType === 'Tiles' ? 'gap: 1em;' : '']])
            }, [
              (_ctx.CookiesData.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.Translate('No Data')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.CookiesData as Array<Catalog>), (catalog) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: catalog.ID,
                  onClick: ($event: any) => (_ctx.$router.push('/Inventory/ViewCatalog/' + catalog.ID)),
                  class: "CatalogImage D-Flex Pointer",
                  style: _normalizeStyle('background-image: url(' + _ctx.DefaultImageHandler(catalog.ImgUrl) + ')')
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", {
                      ToolTip: catalog.Name,
                      class: "M-Auto F-Bold P_5em color3",
                      style: {"font-size":"0.65em","white-space":"nowrap"}
                    }, _toDisplayString(catalog.Name), 9, _hoisted_13)
                  ])
                ], 12, _hoisted_11))
              }), 128))
            ], 4)
          ]),
          (!_ctx.CatalogAvailable && _ctx.Loading.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.ErrorText), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createVNode(_component_WhatsappBuuble)
  ], 64))
}